// let pdfList = [];
//
// document.querySelectorAll('.downloads-v2-section__card').forEach(item => {
//   const title = item.getAttribute('data-title');
//   const link = item.querySelector('a');
//   const url = link ? link.href : null;
//
//   pdfList.push({ title, url });
// });
//
// console.log(pdfList)


const pdfList = [
  {
    "title": "Bona Adhesives",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/Bona_R851_US1_Brochure.pdf?5302"
  },
  {
    "title": "Bona R859",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/bona-r859-tds.pdf?v=1618578401"
  },
  {
    "title": "Bona R581",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/bona-quantum---r851.1.pdf?v=1688565022"
  },
  {
    "title": "Bona Quantum Flow",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/12187---quantum-flow-marketing-materials---sell-sheet_item-4791.pdf?v=1688565010"
  },
  {
    "title": "Bona Quantum 20oz Sausage Tubes",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/bona-quantum-sausage.pdf?v=1688565207"
  },
  {
    "title": "Bona Vertical 10oz Tubes",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/bona-vertical-tds_1.pdf?v=1688565040"
  },
  {
    "title": "Bona Adhesive Trowel",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/10068-bona-adhesive-trowel-sellsheet-4309l_small.pdf?v=1688565337"
  },
  {
    "title": "Bostik’s BEST®",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/Bostiks_Best.pdf?17102125122242279347"
  },
  {
    "title": "Bostik Vapor-Lock™",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/Bostik_Vapor_Lock.pdf?17102125122242279347"
  },
  {
    "title": "Bostik Ultra-Set® SingleStep2™",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/Bostiks_Ultra_Set_Single_Step.pdf?17102125122242279347"
  },
  {
    "title": "Bostik GreenForce™",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/Bostik_Greenforce.pdf?17102125122242279347"
  },
  {
    "title": "Bostik EFA+",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/Bostik_EFA.pdf?5302"
  },
  {
    "title": "Bostik MVP4",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/Bostiks_MVP_59f46cc0-c3b3-493f-9a02-0c26825bcc94.pdf?5299"
  },
  {
    "title": "PID Connect Plus 3.5 Gallon",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/PID-Connect-Plus-Safety-Data-Sheet-3.5G.pdf?v=1702408245"
  },
  {
    "title": "PID Connect Plus 5 Gallon",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/PID-Connect-Plus-Safety-Data-Sheet-5G.pdf?v=1702408245"
  },
  {
    "title": "PID Triple Green 3-in-1 Adhesive",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/PID_TripleGreen_3_in_1_adhesive_V11.pdf?v=1721924543"
  },
  {
    "title": "Data 1",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/PID_Connect_Plus_Technical_Data_Sheet_1.26.20.pdf?v=1651515385"
  },
  {
    "title": "Data 2",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/PID_Floors_Connect_Plus_Safety_Data_Sheet_2.12.18_69.pdf?v=1651515747"
  },
  {
    "title": "PID Connect Plus Sound Test",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/PIDConnectplus_Sound_Test_Report_d00757b8-c783-468f-b4dc-f7982f717ed9.pdf?v=1702656479"
  },
  {
    "title": "PID ALL-IN-ONE Urethane Adhesive",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/Urethane_Flooring_Adhesive_2.pdf?v=1702572370"
  },
  {
    "title": "PID Cut Back Adhesive",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/CUTBACK_SHIELD.pdf?v=1702656479"
  },
  {
    "title": "DriTac 9500",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/DriTac-9500-Ultra-Technical-Data-Sheet-020418.pdf?v=1757359868"
  },
  {
    "title": "DriTac 7900",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/7900-Technical-Data-Sheet.pdf?v=1617915134"
  },
  {
    "title": "DriTac 7800",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/DriTac-7800-Supreme-Green-Technical-Data-Sheet.pdf?5720"
  },
  {
    "title": "DriTac 7700",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/DriTac_7700_Technical_Data_Sheet.pdf?17102125122242279347"
  },
  {
    "title": "DriTac 7400",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/DriTac_7400_Technical-Data-Sheet.pdf?5720"
  },
  {
    "title": "DriTac 7300",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/DriTac_7300-Technical-Data-Sheet.pdf?5720"
  },
  {
    "title": "DriTac 6200",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/DriTac-6200-Technical-Data-Sheet.pdf?v=1679586338"
  },
  {
    "title": "SikaBond®-T100",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/SikaBond_T100_Fact_Sheet.pdf?4296"
  },
  {
    "title": "SikaBond®-T55",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/sikabond_-t55.pdf?v=1617909804"
  },
  {
    "title": "SikaBond®-T35",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/sikabond_-t35.pdf?v=1617914492"
  },
  {
    "title": "SikaBond®-T21",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/fs-dist-SikaBondT21-us.pdf?4296"
  },
  {
    "title": "Sika® AcouBond®-System",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/PID_Floors_Sika_AcouBond_System-us.pdf?9633630174366210924"
  },
  {
    "title": "Roberts 1540",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/1540_PDS_D0418-11180.pdf?v=1617981821"
  },
  {
    "title": "Roberts 1407",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/Roberts_1407_Preferred_Wood_Flooring_Adhsesive.pdf?v=1618322933"
  },
  {
    "title": "Roberts 1404",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/Roberts_1404_Primary_Wood_Flooring_Adhsesive.pdf?v=1618322933"
  },
  {
    "title": "2mm Recycled Rubber Underlayment",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/2MM_Underlayment_Website_2023.pdf?v=1702572370"
  },
  {
    "title": "5mm Recycled Rubber Underlayment",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/5MM_Underlayment_Website_2023.pdf?v=1702572370"
  },
  {
    "title": "10mm Recycled Rubber Underlayment",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/10MM_Underlayment_Website_2023.pdf?v=1702572370"
  },
  {
    "title": "3mm Natural Cork Underlayment",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/3mm_Cork_Underlayment_83e0c3f8-2037-45b2-8c79-b96d7ff90578.pdf?v=1702656479"
  },
  {
    "title": "6mm Natural Cork Underlayment",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/6mm_Cork_Underlayment_d12d6e31-45bc-4523-a0d5-e4fcc6487d5a.pdf?v=1702656480"
  },
  {
    "title": "Bona R540",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/bona-r540.4.pdf?v=1688565032"
  },
  {
    "title": "Sika® Level-125",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/A380-Sika_Level_125.pdf?14995025453931241636"
  },
  {
    "title": "ARDEX K 15®",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/ARDEX-K-15-Technical-Data.pdf?14995025453931241636"
  },
  {
    "title": "Bostik SL-175™",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/Bostik_SL-175.pdf?14995025453931241636"
  },
  {
    "title": "Novoplan® 2 Plus",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/Mapei-novoplan-2-plus-en.pdf?14995025453931241636"
  },
  {
    "title": "PID X Board",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/PID_XBoard_CutSheet.pdf?v=1636043645"
  },
  {
    "title": "The Wagner Meters Smart Logger™ V2",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/smart-logger-slim-jim.pdf?v=1746806074"
  },
  {
    "title": "The Wagner Meters Smart Logger™ V2 manual",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/smart-logger-manual-v2.pdf?v=1746806043"
  },
  {
    "title": "The Wagner Floor Sentry",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/floor-sentry-customer-flyer.pdf?v=1746807311"
  },
  {
    "title": "The Wagner Floor Sentry Manual",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/floor_sentry_manual.pdf?v=1746807310"
  },
  {
    "title": "Bona",
    "url": "https://www.bona.com/en-us/products/homeowners/cleaners/wood-floor/"
  },
  {
    "title": "Bona® Premium Microfiber Mop for Multi-Surface Floors",
    "url": "https://www.bona.com/en-us/products/homeowners/mops/mops/microfiber-floor-mop-duster/"
  },
  {
    "title": "Custom Order Form",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/PID-Custom-Order-Form_63b2bcc2-0271-4a76-bbaa-a070917f51b3.pdf?v=1703003169"
  },
  {
    "title": "Millwork & Accessories",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/Accesories_V25.pdf?v=1702572371"
  },
  {
    "title": "Treads and Risers",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/PID_Floors_Treads_Risers_6793d4ee-aa43-40c5-a43d-a2853a609145.pdf?v=1703108211"
  },
  {
    "title": "Claim Report",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/PID-Claim-Report_6a877fe0-5f7f-4c34-86b6-07ce111d45d2.pdf?v=1703003168"
  },
  {
    "title": "Application Form",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/PID_Floors_Brand_Representation_Application_1.pdf?v=1680728346"
  },
  {
    "title": "Delivery Instructions Form",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/deliveryinstructions_b4a2dde9-5edc-413d-91de-9bfa37a7168d.pdf?v=1703003169"
  },
  {
    "title": "Sales Form",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/Sales_Intake_Form_3a0f1d41-5a88-4699-96cf-71c83a042831.pdf?v=1703003169"
  },
  {
    "title": "Agreement to Borrow Form",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/Agreement_to_Borrow_Boards_NEW_a039ebb2-99e4-4438-a3e0-f94df6dff273.pdf?v=1703003169"
  },
  {
    "title": "Moisture Testing Checklist",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/PID_Moisture_Testing_Checklist_72526eea-2cf1-45d8-ae45-162418f45a6f.pdf?v=1702572370"
  },
  {
    "title": "PID Floors, Volume 1",
    "url": "https://docsend.com/view/bnast79bxtccydk5"
  },
  {
    "title": "PID Floors, Volume 2",
    "url": "https://docsend.com/view/s42m9fdafddibkjc"
  },
  {
    "title": "PID Floors, Volume 3",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/PIDFloors_Catalog_Vol3_Digital_Jan2024_Spread.pdf?v=1707406427"
  },
  {
    "title": "PID Floors, Volume 4",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/PIDFloors_CatalogVolume_4.pdf?v=1744360880"
  },
  {
    "title": "Why Choose PID Floors",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/Why_Choose_PID_Floors.pdf?v=1713990625"
  },
  {
    "title": "Hardened",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/PID_Hardened_Collection_PDF_e7f35ec2-3e62-4cd8-af1b-94042e5191d8.pdf?v=1702656479"
  },
  {
    "title": "Foundation Line",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/PID_FoundationLine_Brochure_V4_8c8681a3-09a2-4271-adad-6d2e27bfac29.pdf?v=1703020071"
  },
  {
    "title": "Portfolio",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/PID_Floors_Portfolio_Brochure_DIGITAL_696f2117-f7fb-41d2-9ca8-42d8ebf4d1e0.pdf?v=1703003169"
  },
  {
    "title": "Products",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/PID_Floors_Products_Brochure_DIGITAL_9c37e010-dcb1-42d0-a18b-e818a6d4e3d8.pdf?v=1703003169"
  },
  {
    "title": "Sustainability",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/PID_Floors_Sustainability_Brochure_DIGITAL_53b68b09-7838-4a6f-bff1-46f4eec2edf7.pdf?v=1703003169"
  },
  {
    "title": "Retail Look Book",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/PID_Floors_Look_Book_Retail_Horizontal_2024.pdf?v=1710943046"
  },
  {
    "title": "Residential Look Book",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/PID_Floors_Residential_Look-Book.pdf?v=1654543547"
  },
  {
    "title": "Multi-Family Look Book",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/PID_Floors_Multi-Family_Look_Book_Highres_398940ec-3069-4272-9bef-10ecfe05946c.pdf?v=1617642808"
  },
  {
    "title": "Commercial Look Book",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/PID_Floors_Commercial_Look_Book.pdf?v=1618508075"
  },
  {
    "title": "Hospitality Look Book",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/PID_Floors_Hospitality_Look_Book_V2.pdf?v=1620232722"
  },
  {
    "title": "Institutional Look Book",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/PID_Floors___Institutional___Look_Book.pdf?v=1620933040"
  },
  {
    "title": "Board Collection",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/BoardCollection_1pagelayouts.pdf?v=1620936985"
  },
  {
    "title": "Chêne Collection",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/CheneCollection_1pagelayout.pdf?v=1620936985"
  },
  {
    "title": "Pure Collection",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/Collection_1pagelayout.pdf?v=1620936985"
  },
  {
    "title": "Drift Collection",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/DriftCollection_1pagelayout.pdf?v=1620936985"
  },
  {
    "title": "Finelock Collection",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/FinelockCollection_1pagelayout.pdf?v=1620936986"
  },
  {
    "title": "InLove Collection",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/inLoveCollection_1pagelayout.pdf?v=1620936985"
  },
  {
    "title": "Liberty Collection",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/Liberty_Collection_PDF_Jan2024.pdf?v=1704312492"
  },
  {
    "title": "Metro Collection",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/MetroCollection_1pagelayouts.pdf?v=1620936985"
  },
  {
    "title": "Modern Collection",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/ModernCollection_1pagelayout.pdf?v=1620936985"
  },
  {
    "title": "RQVI Collection",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/RQVICollection_1pagelayout.pdf?v=1620936985"
  },
  {
    "title": "Traditional Collection",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/TraditionalCollection_1pagelayout.pdf?v=1620936985"
  },
  {
    "title": "Well Treated Collection",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/Well-TreatedCollection_1pagelayout.pdf?v=1620936985"
  },
  {
    "title": "Angles Collection",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/AnglesCollection_1pagelayout.pdf?v=1625592482"
  },
  {
    "title": "Charm Collection",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/CharmCollections_1pagelayout.pdf?v=1625592482"
  },
  {
    "title": "Contractors Collection",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/ContractorsCollection_1pagelayout.pdf?v=1625592482"
  },
  {
    "title": "Core Collection",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/CoreCollection_1pagelayout.pdf?v=1625592482"
  },
  {
    "title": "Cork Collection",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/CorkCollection_1pagelayout.pdf?v=1625592482"
  },
  {
    "title": "Flex Collection",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/FlexCollection_1pagelayout.pdf?v=1625592482"
  },
  {
    "title": "Parquet Collection",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/ParquetCollection_1pagelayout.pdf?v=1625592482"
  },
  {
    "title": "Selected Collection",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/SelectedCollection_1pagelayouts.pdf?v=1625592482"
  },
  {
    "title": "Smart Collection",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/SmartClickCollection_1pagelayout.pdf?v=1625592482"
  },
  {
    "title": "SPC Rigid Core Collection",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/PID_Floors_Rigid_Core_Collection.pdf?v=1684954044"
  },
  {
    "title": "Commercial Hardened Collection",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/PID_Hardened_Collection_PDF.pdf?v=1680724744"
  },
  {
    "title": "Millwork & Accessories",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/Accesories_V25.pdf?v=1702572371"
  },
  {
    "title": "Treads and Risers",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/PID_Floors_Treads_Risers_6793d4ee-aa43-40c5-a43d-a2853a609145.pdf?v=1703108211"
  },
  {
    "title": "Environmental Roundtable Discussion 2022",
    "url": "https://youtu.be/Ubc8QljjMi8?si=ap2A-L2n8P8tv1wV"
  },
  {
    "title": "PID Floors Video | 30 Year Anniversary",
    "url": "https://www.youtube.com/watch?v=7hW4F4TNMqw&ab_channel=PIDFLOORS"
  },
  {
    "title": "Installing a Medallion",
    "url": "https://www.youtube.com/watch?v=Dgcjo7eAJeA&t=3s"
  },
  {
    "title": "How to Create a Parquet Tile",
    "url": "https://www.youtube.com/watch?v=YJ6w-dL61Pc"
  },
  {
    "title": "Wood that changes color-YLT201",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/YLT201.mov?10828969821207569287"
  },
  {
    "title": "Wood that changes color-YLT202",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/YLT202.mov?10828969821207569287"
  },
  {
    "title": "InLove | 1",
    "url": "https://www.youtube.com/watch?v=Z05R7l91PKE"
  },
  {
    "title": "InLove | 2",
    "url": "https://www.youtube.com/watch?v=3SRBtY4XfLQ"
  },
  {
    "title": "InLove | 3",
    "url": "https://www.youtube.com/watch?v=siQIwvQ9Pz4"
  },
  {
    "title": "InLove | 4",
    "url": "https://www.youtube.com/watch?v=7jSQuxg9Kes"
  },
  {
    "title": "InLove | Shou Sugi Ban 1",
    "url": "https://www.youtube.com/watch?v=MGGFYllxMYE"
  },
  {
    "title": "InLove | Shou Sugi Ban 2",
    "url": "https://www.youtube.com/watch?v=pLE_yAWD9Vw"
  },
  {
    "title": "InLove | Shou Sugi Ban 3",
    "url": "https://www.youtube.com/watch?v=rL9MLzc765g"
  },
  {
    "title": "InLove | Shou Sugi Ban 4",
    "url": "https://www.youtube.com/watch?v=ItXJtT_n1-c"
  },
  {
    "title": "InLove | Shou Sugi Ban 5",
    "url": "https://www.youtube.com/watch?v=gIn8ac_voE0"
  },
  {
    "title": "InLove | Shou Sugi Ban 6",
    "url": "https://www.youtube.com/watch?v=gIn8ac_voE0"
  },
  {
    "title": "PID Floors Portfolio Showcase",
    "url": "https://www.youtube.com/watch?v=tUNGrNgiEAY&ab_channel=PIDFLOORS"
  },
  {
    "title": "Our Mission",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/PID_Floors_Mission_Statement_abff8888-ad7a-47b6-83d1-e0306cf49104.pdf?v=1702572370"
  },
  {
    "title": "AIA Materials Pledge",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/PID_AIA_PLEDGE_FINAL.pdf?v=1722968796"
  },
  {
    "title": "Why Choose PID Floors",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/Why_Choose_PID_Floors.pdf?v=1713990625"
  },
  {
    "title": "The Life of a Tree",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/The_life_of_a_tree_e9b6c87d-dd37-41e1-a0a8-ee71176e9de6.pdf?v=1702572370"
  },
  {
    "title": "Formaldehyde",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/Formaldehyde_Document.pdf?v=1702572370"
  },
  {
    "title": "Wood Cuts: The Different Sawn",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/PIDFloors_Woodcuts_Final_71d30657-5d54-4260-8948-b96215825bdf.pdf?v=1702572370"
  },
  {
    "title": "PID Floors Bona Certified Craftsman Maintenance Program",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/PID_Floors_Bona_PDF_Main_44831d49-b0ab-4221-b59e-df4337014979.pdf?v=1702582716"
  },
  {
    "title": "Bona Sustainability Report 2022",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/Bona_Sustainability_Report_-_2022.pdf?v=1694793444"
  },
  {
    "title": "1'' Measurements Chart",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/PID_Floors_Charts4_e120c280-929f-4d8a-9b45-646665edcd79.pdf?v=1632246052"
  },
  {
    "title": "Herringbone VS Chevron",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/PID_Floors_Herringbone_Chevron_Patterns_New_fe8ce975-2273-4a90-ba1f-5af8e05c9ab9.pdf?v=1702572370https://example.com/placeholder.pdf"
  },
  {
    "title": "Steamed VS Unsteamed Walnut",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/steamedunsteamedwalnut.pdf?v=1705604593"
  },
  {
    "title": "Cut Trees to Save The Env.- Who Knew?",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/Cut_Trees_to_Save_the_Environment_f1a7b128-7c44-4652-b24f-259cbcdee195.pdf?v=1702572370"
  },
  {
    "title": "Benefits of Working Forests",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/Benefits_of_Working_Forests_d316b6c6-f343-4942-bfc0-ed5527075e8b.pdf?v=1702572370"
  },
  {
    "title": "Biomass Carbon Neutrality",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/Biomass_Carbon_Neutrality_in_the_Context_of_the_Wood_Products_Industry_db9f0cdb-42b8-4b52-bbff-2f998ab9d4b5.pdf?v=1702572370"
  },
  {
    "title": "Greening the Earth",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/Greening_the_earth_c6e12db2-76eb-4105-8ae8-ba37b29b3c95.pdf?v=1702572370"
  },
  {
    "title": "World Environment Day",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/World_Environment_Day2022_PDF_5b4bae2e-3bdf-47c1-883c-63622e9dc33c.pdf?v=1702656370"
  },
  {
    "title": "MAS Certified Green",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/2026-01_PID_Floors_SPC_Rigid_Core_Vinyl_Flooring_2400783_2.pdf?v=1737642172"
  },
  {
    "title": "FSC SCS Certificate",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/FSC_SCS_Certificate_2021_to_2026.pdf?v=1642525365"
  },
  {
    "title": "Indoor Air Quality/Volatile Organic Comp.",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/PID_Floors_Indoor_Air_Quality_c075b844-415a-442e-b139-babe57aa99d0.pdf?v=1702572370"
  },
  {
    "title": "Guide to Understanding Eco Cert. & Labels",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/Guide_to_Understand_Eco_Certificates___Labels.pdf?v=1702572370"
  },
  {
    "title": "USGBC Membership Certification",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/USGBC_Membership_Certification.pdf?v=1645045844"
  },
  {
    "title": "PID + FSC",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/PID_FSC_211237ad-32a3-4305-b65c-f2db60cbeb05.pdf?v=1703018992"
  },
  {
    "title": "NWFA | PID 2025 Refinishable Certificate",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/PID_2025_Refinishable_Certificate.pdf?v=1754575841"
  },
  {
    "title": "USDA Life-Cycle Assessment",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/fpl_rp718.pdf?v=1698162813"
  },
  {
    "title": "Color Theory",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/PID_Floors_Color_Theory_ecfe0659-f678-47f4-b65c-36975402e2b7.pdf?v=1702572370"
  },
  {
    "title": "American Forests & PID Floors Q&A",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/AF_and_PID_Floors_Q_A_5fe30f9d-dec3-42a5-a9c5-5d791b6afce7.pdf?v=1702572370"
  },
  {
    "title": "Custom Textures",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/PID_Floors_Custom_Textures_6fc33ace-f249-4653-b526-f988495365f0.pdf?v=1702572370"
  },
  {
    "title": "Millwork & Accessories",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/Accesories_V25.pdf?v=1702572371"
  },
  {
    "title": "Flame Spread Testing",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/Flame_spread_testing_d6ae7d86-8dcc-49d4-af35-c3f7b9f89117.pdf?v=1703003168"
  },
  {
    "title": "PID Floors | AprilAir Wood Protection",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/PID_AprilAire_WoodProtection.pdf?v=1709669776"
  },
  {
    "title": "PID Floors | AprilAir Humidity",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/PID_AprilAire_Humidity.pdf?v=1709669772"
  },
  {
    "title": "PID Floors | AprilAir DryairPID",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/PID_AprilAire_dryair.pdf?v=1709669769"
  },
  {
    "title": "Value of Wood Floors",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/Value_of_Wood_Floors.pdf?v=1713462430"
  },
  {
    "title": "Wood Floors are Durable",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/Wood_Floors_are_Durable.pdf?v=1713462431"
  },
  {
    "title": "Environmental Health Benefits of Wood Floors",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/Environmental_Health_Benefits_of_Wood_Floors.pdf?v=1713454526"
  },
  {
    "title": "Homeowners Handbook to Real Wood Floors",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/Homeowners_Handbook_to_Real_Wood_Floors_web-1.pdf?v=1713452790"
  },
  {
    "title": "Caring for Wood Floors is Easy",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/Caring_for_Wood_Floors_is_Easy.pdf?v=1713541936"
  },
  {
    "title": "NWFA ≈ Life Cycle Analysis",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/Life_Cycle_Analysis_5da14a8e-fe9a-4e9f-8e97-3a5824d34699.pdf?v=1632146312"
  },
  {
    "title": "Relative Humidity",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/Relative_Humidity.pdf?2196"
  },
  {
    "title": "Volatile Organic Compounds",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/Volatile_Organic_Compounds.pdf?2196"
  },
  {
    "title": "Wood Species",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/Wood_Species_6e91d10f-841c-4d6e-ac76-66a6dddc1816.pdf?v=1710603143"
  },
  {
    "title": "NWFA/NOFMA International Standards for Unfinished Solid Wood Flooring",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/NWFA_PDF_90db8387-a521-4d03-99df-6607c0707f27.pdf?v=1663259277"
  },
  {
    "title": "EPD Solid Flooring",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/Solid_Wood_Flooring_EPD_20221129.pdf?v=1671213556"
  },
  {
    "title": "EPD Engineered Flooring",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/Engineered_Wood_Flooring_EPD_20221129.pdf?v=1671213556"
  },
  {
    "title": "PID Floors & NWFA 1-11 CEU Course Outline",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/PID_Courses_NWFA_Courses_Aug2025.pdf?v=1757925819"
  },
  {
    "title": "Course 1 I Cork, Bamboo, and Wood as a Flooring Material",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/PID_NWFA_Course_1.pdf?v=1747029511"
  },
  {
    "title": "Course 2 I Engineered Wood Flooring",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/PID_NWFA_Course_2.pdf?v=1747029511"
  },
  {
    "title": "Course 3 I Environmental Impacts of Real Wood Floors",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/PID_NWFA_Course_3_3effdc32-077d-489f-8c5c-b7302aaa488c.pdf?v=1757925126"
  },
  {
    "title": "Course 4 I From the Forest to the Floor",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/PID_NWFA_Course_4.pdf?v=1747029511"
  },
  {
    "title": "Course 5 I Hardwood Flooring Grades",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/PID_NWFA_Course_5.pdf?v=1747029511"
  },
  {
    "title": "Course 6 I  Maintaining & Refinishing Wood Floors",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/PID_NWFA_Course_6.pdf?v=1747029511"
  },
  {
    "title": "Course 7 I Wood Flooring 101",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/PID_NWFA_Course_7.pdf?v=1747029511"
  },
  {
    "title": "Course 8 I Wood Flooring in Commercial Projects",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/PID_NWFA_Course_8.pdf?v=1747029511"
  },
  {
    "title": "Course 9 I Wood Flooring Saw Cuts: Appearance & Performance Attributes",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/PID_NWFA_Course_9.pdf?v=1747029511"
  },
  {
    "title": "Course 10 I Wood Flooring Species",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/PID_NWFA_Course_10.pdf?v=1747029511"
  },
  {
    "title": "Course 11 I Wood Flooring Trends",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/PID_NWFA_Course_11.pdf?v=1747029511"
  },
  {
    "title": "PID Floors Winter Floor Care 101",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/PID_Floors_Winter_Floor_Care_101.pdf?v=1738656832"
  },
  {
    "title": "PID Pulse Introduction",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/PID_Pulse_Introduction_V10_1.pdf?v=1752681091"
  },
  {
    "title": "Installing Ornamental Floors",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/Ornamental_Floors.pdf?13449668179715049218"
  },
  {
    "title": "Moisture and Wood",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/Moisture_and_Wood.pdf?244"
  },
  {
    "title": "Acclimation",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/NWFA_Acclimation.pdf?v=1709155350"
  },
  {
    "title": "Regional Climate Variation",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/Regional_Climate_Variation_Final_Update_1-8-20.pdf?v=1709155396"
  },
  {
    "title": "Jobsite Checklist",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/Jobsite_Checklist.pdf?v=1709155414"
  },
  {
    "title": "Installation General Guidelines",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/NWFA_Installation_Guidelines_Final_1.pdf?v=1667568817"
  },
  {
    "title": "Subfloor Guidelines",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/NWFA_GUIDE_3_-_Subfloor_Guidelines.pdf?2665941115676138301"
  },
  {
    "title": "Maintenance and Recoating",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/NWFA_Maintenance_and_Recoating.pdf?2956698667933849760"
  },
  {
    "title": "Care and Maintenance",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/NWFA_Care_and_Maintenance.pdf?2518324152102043664"
  },
  {
    "title": "Concrete Subfloor Guidelines",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/NWFA_Installation_Guidelines_Concete_Subfloors_copy.pdf?v=1619704027"
  },
  {
    "title": "Appendices",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/NWFA_GUIDE_5_-_Appendices.pdf?1044320390996935043"
  },
  {
    "title": "Janka Rating Diagram",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/Janka.pdf?2169"
  },
  {
    "title": "Addressing Water Damage",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/Addressing_Water_Damage_1.pdf?2196"
  },
  {
    "title": "Grading and Packaging",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/Grading_Master.pdf?2196"
  },
  {
    "title": "Relative Humidity",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/Relative_Humidity.pdf?2196"
  },
  {
    "title": "Wood Species",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/Wood_Species_6e91d10f-841c-4d6e-ac76-66a6dddc1816.pdf?v=1710603143"
  },
  {
    "title": "REPAIR/REPLACEMENT/REMOVAL",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/Pages_from_NWFA_Installation_Guidelines_Final.pdf?v=1617288178"
  },
  {
    "title": "NWFA/NOFMA International Standards for Unfinished Solid Wood Flooring",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/NWFA_PDF_90db8387-a521-4d03-99df-6607c0707f27.pdf?v=1663259277"
  },
  {
    "title": "NWFA Radiant Heat",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/NWFA_Installation_Guidelines_-_Radiant_Heat.pdf?v=1683213985"
  },
  {
    "title": "Life Cycle Costs For Wood Flooring Assessment",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/Life_Cycle_Costs_For_Wood_Flooring_Assessment.pdf?v=1713542026"
  },
  {
    "title": "Life Cycle Costs for Flooring in Commercial Buildings Floor Covering Comparison Study",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/Life-Cycle_Costs_for_Flooring_in_Commercial_Buildings_Floor_Covering_Comparison_Study.pdf?v=1713542279"
  },
  {
    "title": "Benefits of Active Forest Management",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/Benefits_of_Forest_Management_-_April_2021.pdf?v=1626716993"
  },
  {
    "title": "Sustainability of American Hardwood",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/Sustainability_of_Hardwoods_-_2021.pdf?v=1626716993"
  },
  {
    "title": "Reducing Carbon Emissions",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/Reducing_Carbon_Emissions_by_Using_Wood_Products_and_Life_Cycle_Analysis.pdf?v=1627580150"
  },
  {
    "title": "Wood Industry Report 2022",
    "url": "https://cdn.shopify.com/s/files/1/2953/2504/files/Recent_Data_Wood_industry_Report.pdf?v=1657289209"
  }
]

// PDF Search Integration System
class SimplePDFSearch {
  constructor() {
    this.pdfFiles = pdfList;
    this.init();
  }

  init() {
    this.addStyles();
    this.checkAndDisplayResults();
  }

  isPDFSearch() {
    const urlParams = new URLSearchParams(window.location.search);
    const type = urlParams.get('type');

    // Show PDF results if:
    // - no type param
    // - or type includes 'pdf'
    return !type || type.toLowerCase().split(',').includes('pdf');
  }


  // Get search query from URL
  getSearchQuery() {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get('q') || urlParams.get('search') || '';
  }

  // Search PDFs
  searchPDFs(query) {
    if (!query || query.length < 2) return [];

    const searchTerms = query.replace(/\*/g, '').toLowerCase().split(' ').filter(term => term.length > 0);

    return this.pdfFiles.filter(pdf => {
      const title = pdf.title.toLowerCase();
      return searchTerms.some(term => title.includes(term));
    });
  }

  shouldHideShopifyResults() {
    const urlParams = new URLSearchParams(window.location.search);
    const type = urlParams.get('type');

    // Only hide Shopify results if type is strictly 'pdf'
    return type && type.toLowerCase().trim() === 'pdf';
  }

  // Check for search query and display results
  checkAndDisplayResults() {
    const searchQuery = this.getSearchQuery();

    if (this.isPDFSearch() && searchQuery) {
      const matchingPDFs = this.searchPDFs(searchQuery);

      if (matchingPDFs.length > 0) {
        this.displayResults(matchingPDFs);
        this.hideEmptyState();
      } else if (this.shouldHideShopifyResults()) {
        this.displayEmptyState();
      }
    }

    // Conditionally hide Shopify's search results
    if (this.shouldHideShopifyResults()) {
      const nativeResults = document.querySelector('.new-search-result');
      if (nativeResults) {
        nativeResults.style.display = 'none';
        document.querySelector('.new-pagination').style.display = 'none';
      }
    }
  }

  hideEmptyState() {
    const hint = document.querySelector('[data-search-empty-hint]');
    if (hint) hint.style.display = 'none';
    document.querySelector('[data-pdf-search-empty]')?.remove();
  }

  displayEmptyState() {
    const related = document.querySelector('.new-search-result');
    if (related) related.style.display = 'none';

    const hint = document.querySelector('[data-search-empty-hint]');
    if (hint) {
      hint.style.display = '';
      return;
    }

    const searchGrid = document.querySelector('.search-grid-container');
    if (!searchGrid || searchGrid.querySelector('[data-pdf-search-empty]')) return;

    const el = document.createElement('h5');
    el.className = 'h5 title text-center';
    el.setAttribute('data-pdf-search-empty', '');
    el.innerHTML =
      'If you can’t find exactly what you are looking for, feel free to contact us to <a href="mailto:info@pidfloors.com">Learn More</a>';
    searchGrid.appendChild(el);
  }
  displayResults(pdfs) {
    const html = this.createResultsHTML(pdfs);
    this.insertResults(html);
  }


  // Create HTML for results
  createResultsHTML(pdfs) {
    const resultsHTML = pdfs.map(pdf => `
      <div class="grid product pdf-result-item">
        <div class="">
          <div class="pdf-result-icon-container">
            <div class="pdf-result-icon">📄</div>
          </div>
        </div>
        <div class="grid__item five-sixths">
          <a href="${pdf.url}" class="product__copy-text" style="color: rgb(64, 64, 177); font-weight: 400; font-size: 12px; text-decoration: underline; text-decoration-color: black; position: absolute; transform: translateX(90000px);" target="_blank">${pdf.title}</a>
          <p class="h3--body search__product">
            <a href="${pdf.url}" title="${pdf.title}" target="_blank">${pdf.title}</a>
            <button class="product__copy-btn pdf-copy-btn" aria-label="Copy PDF link" data-pdf-url="${pdf.url}" data-pdf-title="${pdf.title}">
              <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1.96286 16.0373C2.38255 16.4576 2.88116 16.7908 3.43003 17.0179C3.97891 17.2449 4.56723 17.3612 5.16119 17.3601C5.75528 17.3611 6.34373 17.2448 6.89275 17.0178C7.44176 16.7908 7.94054 16.4576 8.36043 16.0373L10.9191 13.4778L9.63976 12.1984L7.08109 14.758C6.57123 15.2656 5.88108 15.5505 5.16164 15.5505C4.4422 15.5505 3.75205 15.2656 3.24219 14.758C2.73417 14.2484 2.4489 13.5581 2.4489 12.8385C2.4489 12.119 2.73417 11.4287 3.24219 10.9191L5.80176 8.36043L4.52243 7.08109L1.96286 9.63976C1.11582 10.4888 0.640137 11.6392 0.640137 12.8385C0.640137 14.0379 1.11582 15.1883 1.96286 16.0373V16.0373ZM16.0373 8.36043C16.8839 7.51111 17.3593 6.36083 17.3593 5.16164C17.3593 3.96245 16.8839 2.81217 16.0373 1.96286C15.1883 1.11582 14.0379 0.640137 12.8385 0.640137C11.6392 0.640137 10.4888 1.11582 9.63976 1.96286L7.08109 4.52243L8.36043 5.80176L10.9191 3.24219C11.429 2.73461 12.1191 2.44964 12.8385 2.44964C13.558 2.44964 14.2481 2.73461 14.758 3.24219C15.266 3.75182 15.5513 4.44205 15.5513 5.16164C15.5513 5.88123 15.266 6.57147 14.758 7.08109L12.1984 9.63976L13.4778 10.9191L16.0373 8.36043Z" fill="black"></path>
                <path d="M5.80075 13.4786L4.52051 12.1993L12.1992 4.52148L13.4786 5.80172L5.80075 13.4786Z" fill="black"></path>
              </svg>
              <span class="product__text-on-hover">Copy PDF link</span>
            </button>
          </p>
          <div class="pdf-download-section">
            <a href="${pdf.url}" target="_blank" class="pdf-download-link">Download PDF</a>
          </div>
        </div>
      </div>
    `).join('');

    return `
      <div class="pdf-search-section">
        <h3 class="pdf-section-title h2">Related documents (${pdfs.length})</h3>
        <div class="pdf-results-container">
          ${resultsHTML}
        </div>
      </div>
    `;
  }

  // Insert results before search grid
  insertResults(html) {
    const searchGrid = document.querySelector('.search-grid-container');
    if (searchGrid) {
      // Create PDF block as last child inside search grid
      const pdfBlock = document.createElement('div');
      pdfBlock.className = 'pdf-search-block';
      pdfBlock.innerHTML = html;
      searchGrid.appendChild(pdfBlock);
      // Setup copy functionality
      this.setupCopyButtons();
    }
  }

  // Setup copy button functionality
  setupCopyButtons() {
    document.addEventListener('click', async function (e) {
      if (e.target.closest('.pdf-copy-btn')) {
        e.preventDefault();
        const copyBtn = e.target.closest('.pdf-copy-btn');
        const pdfUrl = copyBtn.getAttribute('data-pdf-url');
        const pdfTitle = copyBtn.getAttribute('data-pdf-title') || 'PDF Document'; // Get title from data attribute or use default

        if (pdfUrl) {
          // Create rich text content for clipboard (like YouTube links in Gmail)
          const createRichClipboardData = async () => {
            // Create a temporary div to generate proper HTML content
            const tempDiv = document.createElement('div');
            const link = document.createElement('a');
            link.href = pdfUrl;
            link.textContent = pdfTitle;
            link.target = '_blank';
            tempDiv.appendChild(link);

            const htmlContent = tempDiv.innerHTML;

            return new ClipboardItem({
              'text/html': new Blob([htmlContent], {type: 'text/html'}),
              'text/plain': new Blob([pdfTitle], {type: 'text/plain'})
            });
          };

          // Copy the rich text content
          navigator.clipboard.write([await createRichClipboardData()]).then(() => {
            const tooltip = copyBtn.querySelector('.product__text-on-hover');
            const originalText = tooltip.textContent;
            tooltip.textContent = 'Copied!';
            setTimeout(() => {
              tooltip.textContent = originalText;
            }, 2000);
          }).catch(() => {
            // Fallback: try with writeText for older browsers
            navigator.clipboard.writeText(pdfUrl).then(() => {
              const tooltip = copyBtn.querySelector('.product__text-on-hover');
              const originalText = tooltip.textContent;
              tooltip.textContent = 'Copied!';
              setTimeout(() => {
                tooltip.textContent = originalText;
              }, 2000);
            }).catch(() => {
              // Final fallback for very old browsers
              const textArea = document.createElement('textarea');
              textArea.value = pdfUrl;
              document.body.appendChild(textArea);
              textArea.select();
              document.execCommand('copy');
              document.body.removeChild(textArea);
            });
          });
        }
      }
    });
  }

  // Add CSS styles
  addStyles() {
    if (document.getElementById('pdf-search-styles')) return;

    const styles = `
      <style id="pdf-search-styles">
        .pdf-search-block {
          width: 100%;
          margin-bottom: 30px;
        }

        .pdf-search-section {
          margin: 0;
          /*padding: 20px;*/
          /*background: #f8f9fa;*/
          border-radius: 8px;
          /*border-left: 4px solid #dc3545;*/
          width: 100%;
          /*box-shadow: 0 2px 4px rgba(0,0,0,0.1);*/
        }

        .pdf-section-title {
          margin: 0 0 20px 0;
          display: flex;
          align-items: center;
          gap: 10px;
        }

        .pdf-section-title::before {
          content: "📄";
          font-size: 28px;
        }

        .pdf-results-container {
          display: block;
        }

        .pdf-result-item {
          margin-bottom: 5px!important;
          padding: 15px;
          background: white;
          /*border-radius: 6px;*/
          border: 1px solid #e9ecef;
          transition: all 0.2s ease;
        }

        /*.pdf-result-item:hover {*/
        /*  border-color: #dc3545;*/
        /*  box-shadow: 0 4px 12px rgba(220,53,69,0.15);*/
        /*  transform: translateY(-2px);*/
        /*}*/

        .pdf-result-item:last-child {
          margin-bottom: 0;
        }

        .pdf-result-icon-container {
          display: flex;
          align-items: center;
          justify-content: center;
          height: 100%;
          min-height: 80px;
        }

        .pdf-result-icon {
          font-size: 48px;
          color: #dc3545;
        }

        .pdf-download-section {
          margin-top: 15px;
        }

        .pdf-download-link {
          display: inline-block;
          color: #000;
          font-size: 16px;
          font-weight: 500;
          transition: background-color 0.2s;
          text-decoration: underline;
        }

        .pdf-copy-btn {
          position: relative;
        }

        .pdf-copy-btn .product__text-on-hover {
          position: absolute;
          bottom: 100%;
          left: 50%;
          transform: translateX(-50%);
          background: rgba(0,0,0,0.8);
          color: white;
          padding: 4px 8px;
          border-radius: 4px;
          font-size: 12px;
          white-space: nowrap;
          opacity: 0;
          pointer-events: none;
          transition: opacity 0.2s;
          z-index: 10;
        }

        .pdf-copy-btn:hover .product__text-on-hover {
          opacity: 1;
        }

        .pdf-search-block + .search-grid__main::before {
          content: "";
          display: block;
          height: 2px;
          background: linear-gradient(90deg, #dc3545, transparent);
          margin-bottom: 20px;
          border-radius: 1px;
        }

        @media (max-width: 768px) {
          .pdf-search-section {
            padding: 15px;
          }

          .pdf-section-title {
            font-size: 20px;
          }

          .pdf-result-item .grid__item.one-sixth,
          .pdf-result-item .grid__item.five-sixths {
            width: 100%;
            float: none;
          }

          .pdf-result-icon-container {
            min-height: 60px;
            margin-bottom: 10px;
          }

          .pdf-result-icon {
            font-size: 36px;
          }
        }
      </style>
    `;

    document.head.insertAdjacentHTML('beforeend', styles);
  }
}

// Initialize on page load
document.addEventListener('DOMContentLoaded', function () {
  // Check if this is a search page
  const url = window.location.href;
  const hasSearchQuery = new URLSearchParams(window.location.search).has('q') ||
    new URLSearchParams(window.location.search).has('search') ||
    url.includes('/search');

  if (hasSearchQuery) {
    console.log('Search page detected, initializing PDF search...');
    setTimeout(() => {
      new SimplePDFSearch();
    }, 500);
  }
});

if (document.readyState === 'complete') {
  const url = window.location.href;
  const hasSearchQuery = new URLSearchParams(window.location.search).has('q') ||
    new URLSearchParams(window.location.search).has('search') ||
    url.includes('/search');

  if (hasSearchQuery) {
    setTimeout(() => {
      new SimplePDFSearch();
    }, 500);
  }
}


function bindSearchSelectSubmit() {
  document.querySelectorAll('form[action="/search"] select[name="type"]').forEach(select => {
    if (!select.dataset.bound) {
      select.addEventListener('change', () => {
        const form = select.closest('form');
        if (form) {
          // Sync visible input to hidden input
          const searchField = form.querySelector('#searchfield');
          const searchQuery = form.querySelector('#searchquery');

          if (searchField && searchQuery) {
            searchQuery.value = searchField.value;
          }

          form.submit();
        }
      });
      select.dataset.bound = 'true';
    }
  });
}

document.addEventListener('DOMContentLoaded', () => {
  bindSearchSelectSubmit();
});
